import type { ExportColumnKeys } from "@/modules/export";
import type { RolesColumnKey } from "./roles.types";

/** Coluna da tela de Perfis → chave do core na exportação (`null`: fora do arquivo). */
export const ROLES_EXPORT_COLUMN_KEYS: ExportColumnKeys<RolesColumnKey> = {
  codigo: "codigo",
  nome: "nome",
  permissoes: "permissoes",
  quantidadeUsuarios: "usuarios",
  acoes: null,
};
